var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-dialer-main-page", {
    attrs: {
      avatar: _vm.avatar,
      agent: _vm.agent,
      contact: _vm.contact,
      identifier: _vm.identifier,
      description: _vm.description,
      members: _vm.members,
      timestamp: _vm.timestamp,
      "session-id": _vm.sessionId,
      "is-connecting": _vm.isConnecting,
      "is-in-progress": _vm.isInProgress,
      "is-on-hold": _vm.isContactOnHold,
      "is-muted": _vm.isAgentMuted,
      "is-put-on-hold-action-loading": _vm.isPutOnHoldActionLoading,
      "is-hang-up-action-loading": _vm.isHangUpActionLoading,
      "has-keypad-button": _vm.hasKeypadButton,
      "has-invite-button": _vm.hasInviteButton,
      "has-transfer-button": _vm.hasTransferButton,
      "has-mute-button": _vm.hasMuteButton,
      "has-hold-button": _vm.hasHoldButton,
    },
    on: {
      "toggle-keypad": function ($event) {
        return _vm.$emit("toggle-keypad")
      },
      "toggle-members-page": function ($event) {
        return _vm.$emit("toggle-members-page")
      },
      "toggle-invite-page": function ($event) {
        return _vm.$emit("toggle-invite-page")
      },
      "toggle-transfer-page": function ($event) {
        return _vm.$emit("toggle-transfer-page")
      },
      "put-on-hold": _vm.onTogglePutOnHold,
      "mute-self": _vm.onToggleMuteSelf,
      "hang-up": _vm.onHangUp,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }